import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import useConfiguration from "../../hooks/useConfiguration";
import useSessionStorage from "../../hooks/useSessionStorage";
import Error from '../common/Message/error';
import Success from "../common/Message/success";
import DeleteContactModal from '../common/Modal/deleteContactModal';
import Table from "../common/Table";
import { deleteEmployerUser, getContactList, getLocationDropdownList, updatesuccessmessage } from "./action";
import { contactsSelector } from "./selector";
import { addLocationSelector } from "../AddLocation/endpoints/selector";

// eslint-disable-next-line import/no-anonymous-default-export
export default (props) => {
  let contacts = props.contactList;
  let fromAddLocation = props.fromAddLocation;
  let locationId = props.locationId;
  const navigate = useNavigate();
  const config = useConfiguration();
  const storage = useSessionStorage();
  const login = storage.getItem('login');
  const { contactList, locationDropdownList, successMessage, errorMessage, count, loader } = useSelector(contactsSelector);
  const [contactsList, setContactsList] = useState([]);
  const [locationsDropdownList, setLocationDropdownList] = useState([]);
  const [filterList, setFilterList] = useState([]);
  const [contact, setContact] = useState([]);
  const [showDelete, setShowDelete] = useState(false);
  const [deleteId, setDeleteId] = useState('');
  const [LocdeleteId, setLocDeleteId] = useState('');
  const [formMessage, setFormMessage] = useState('');
  const dispatch = useDispatch();
  const { newlocationid } = useSelector(addLocationSelector);

  // console.log(contacts);
  // console.log(successMessage)
  useEffect(() => {
    if (config.baseUrl) {
      setFormMessage('');
      if (fromAddLocation) {
        if (locationId || newlocationid) {
          const id = newlocationid ? newlocationid : locationId;
          dispatch(getContactList(config.baseUrl, login.employerUniqueId, id));
        }
        else {
          dispatch(getContactList(config.baseUrl, login.employerUniqueId, contacts.locationId));

        }

      } else {
        dispatch(getContactList(config.baseUrl, login.employerUniqueId, 0));
      }

      dispatch(getLocationDropdownList(config.baseUrl, login.employerId));
    }
  }, [config]);

  useEffect(() => {
    return () => { dispatch(updatesuccessmessage(null)) }
  }, []);
  useEffect(() => {
    if (successMessage !== null && successMessage === 'Deleted') {
      setFormMessage('Employer Contact details deleted successfully!');

      if (fromAddLocation) {
        config.baseUrl && dispatch(getContactList(config.baseUrl, login.employerUniqueId, contacts.locationId));
      } else {
        config.baseUrl && dispatch(getContactList(config.baseUrl, login.employerUniqueId, 0));
      }
    }
  }, [count]);

  useEffect(() => {
    if (errorMessage !== null)
      setFormMessage(errorMessage)
  }, [errorMessage]);

  useEffect(() => {
    if (LocdeleteId) {
      let filteredList = [];
      filteredList = contactList.filter(item => {
        if (item.locationId === LocdeleteId) {
          return item;
        }

      });
      setFilterList(filteredList);
    } else {
      setContactsList(contactList);
    }
  }, [contactList]);

  useEffect(() => {
    if (locationDropdownList.length > 0) {
      setLocationDropdownList(locationDropdownList);
    }
  }, [locationDropdownList]);

  useEffect(() => {
    if (contactsList.length > 0) {
      setFilterList(contactsList);
    } else {
      setFilterList([]);
    }
  }, [contactsList]);

  useEffect(() => {
    if (fromAddLocation) {
      setContact(contacts);
    }
  }, [fromAddLocation]);

  const editUser = (row) => {
    navigate("/adduser",
      {
        state: {
          editUser: true,
          name: row.locationName,
          userDetails: row,
        }
      })
  }

  const showDeleteModal = (row) => {
    setShowDelete(true);
    setDeleteId(row.contactId)
  }

  const handleDeleteClose = () => setShowDelete(false);

  const handleDelete = () => {
    dispatch(deleteEmployerUser(config.baseUrl, deleteId, login.appUserId));
    setShowDelete(false);
  }

  const filterLocation = (id) => {
    const locationId = parseInt(id);
     setLocDeleteId(locationId);
     if(!isNaN(locationId)){
      dispatch(getContactList(config.baseUrl, login.employerUniqueId, locationId));
     }
  }

  const columns = React.useMemo(
    () => [
      {
        Header: 'Name',
        accessor: 'firstName',
        width: 170
      },
      {
        Header: 'Employee ID',
        accessor: 'employeeId',
      },
      {
        Header: 'Cell Phone #',
        accessor: 'cellPhoneNumber',
        width: 200,
      },
      {
        Header: 'Work Phone #',
        accessor: 'workNumber',
        width: 200,
      },
      {
        Header: 'Email Address',
        accessor: 'email',
        width: 200,
      },
    ],
    [],
  );

  return (
    <div class="panel-body tabs-menu-body">
      <div class="tab-content">
        <div class="tab-pane active" id="tab25">
          <div class="col-xl-14">
            <div>
              <div>
                {
                  errorMessage && <Error errorMessage={formMessage} />
                }
                {
                  successMessage && <Success successMessage={formMessage} />
                }
                {!fromAddLocation &&
                  <div class="row">
                    <div class="col-lg-12 col-md-12">
                      <div class="form-group">
                        <label class="form-label">Location Name</label>
                        <select
                          name="Templates"
                          class="form-control form-select"
                          data-bs-placeholder="Select Template"
                          onChange={(e) => filterLocation(e.target.value)}
                        >
                          <option>
                            -- Select --
                          </option>
                          {locationsDropdownList.length !== 0 && locationsDropdownList.map((area, n) => (
                            <option key={`traveldistance_${n}`} value={area.id}>
                              {area.name}
                            </option>
                          ))}
                        </select>
                      </div>
                    </div>
                  </div>
                }
                {
                  loader && filterList && filterList.length === 0 ? (<div class="errorMessage">Loading...</div>) :
                    !fromAddLocation && !loader && filterList && filterList.length === 0 ? <div class="errorMessage">No Records Found</div> : ''
                }
                {!fromAddLocation && filterList && <Table id="contactTable" columns={columns} data={filterList} edit={editUser} showDeleteModal={showDeleteModal} />}

                {
                  loader && contactList && contactList.length === 0 ? (<div class="errorMessage">Loading...</div>) :
                    fromAddLocation && !loader && contactList && contactList.length === 0 ? <div class="errorMessage">No Records Found</div> : ''
                }
                {fromAddLocation && contactList && contactList.length > 0 && <Table id="contactTable" columns={columns} data={contactList} edit={editUser} showDeleteModal={showDeleteModal} />}
              </div>
            </div>
          </div>

          {/* Delete Modal Component */}
          <DeleteContactModal showDelete={showDelete} handleDeleteClose={handleDeleteClose} handleDelete={handleDelete} />
        </div>
      </div>
    </div>
  );
};
